export const normalizeMoneyInput = (value, allowNegative) => {
    const rawValue = String(value ?? "").replaceAll("$", "").trim();
    const hasNegativeSign = allowNegative && rawValue.startsWith("-");
    const digits = rawValue.replace(/\D/g, "");
    return `${hasNegativeSign ? "-" : ""}${digits}`;
};

export const isValidMoneyValue = (value, allowNegative) => {
    const pattern = allowNegative ? /^-?\d+$/ : /^\d+$/;
    return pattern.test(String(value ?? ""));
};

export const getPaidLessonsCount = (balance, lessonPrice) => {
    const numericBalance = Number(balance);
    const numericLessonPrice = Number(lessonPrice);
    if (
        !Number.isFinite(numericBalance) ||
        !Number.isFinite(numericLessonPrice) ||
        numericLessonPrice <= 0
    ) {
        return 0;
    }
    return Math.max(Math.floor(numericBalance / numericLessonPrice), 0);
};
